import { SERPEvent, SERPEventType } from '../SERPEvents';

export type ResetQueryEvent = CustomEvent & {
    type: SERPEventType.RESET_QUERY;
};

export const isResetQueryEvent = (event: SERPEvent): event is ResetQueryEvent => {
    return typeof event === 'object' && event !== null && 'type' in event && event.type === SERPEventType.RESET_QUERY;
};
